import React from 'react';
import './style.css';
import { Typography } from "@mui/material";

class PositionDateName extends React.Component {

    render() {
        return (
        <div id='position_date_name'>
            <Typography>
                {this.props.tourName}
            </Typography>
        </div>
        )
    }
    
}
export default PositionDateName;
